function euroSportBreadcrumb(){
	return {
		models:
		[
		 	{
		 		modelName: "CCU"
		 	}
		],
		views:
		[
		 	{
		 		viewName: "CCU",
		 		partial: "common/euro_sport_breadcrumb/euro_sport_breadcrumb",
		 		innerTarget: ".selections",
				filters: {},
                autoUpdate: true,
                events: {
                    'click #sportSelectionTrail' : 'handleBreadCrumbSportNavigation'
                },
		 		beforeInitialize: function(){
					this.targetEl = this.model.get("targetEl");
					if(Config.ACTION == 'search'){
						this.setSearchTitles();
					}else{
						if(Config.VIEW_NAME == 'euro-view'){
                            var filters = getBreadcrumb();
                            this.updateBreadCrumbSelection(null, filters);
						}else{
							this.model.set('renderElement', false);
						}

					}

		 		},
				afterInitialize: function() {
                    this.on('SidebarNavigation_updateSelection', this.updateBreadCrumbSelection);
				},

				setSearchTitles: function(){
                    if(Config.ACTION == 'search'){
                    	var textSearch = TRANSLATIONS.search_title ? TRANSLATIONS.search_title : 'TRANSLATIONS.search_title';
                    	var searchTerm = getParameterByName('search') ? getParameterByName('search') : '';
                        this.model.set({
                            sport_selection: textSearch + ' - "' + searchTerm + '"',
						});
                    }
				},
                updateBreadCrumbSelection: function(caller, data) {
                    var customCouponLabel = TRANSLATIONS.multiple_selection ? TRANSLATIONS.multiple_selection : "JS.multiple_selection";

                    if(_.isEmpty(data)) {
                    	return;
					}

		 			this.filters = data;

		 			if(data.sport_title) {
                        this.model.set('sport_selection', data.sport_title);
					}

					if(data.league_id && data.league_id.length === 1) {
						this.model.set('league_selection', data.league_title_locale ? data.league_title_locale : data.league_title);
					} else if(data.league_id && data.league_id.length > 1) {
						this.model.set('league_selection', customCouponLabel);
					} else {
                        this.model.set('league_selection', "");
					}
				},
                handleBreadCrumbSportNavigation: function() {
                    if(Config.ACTION == 'search'){
                    	return;
                    }
					var $sidebarSportNav = $('#sidebarSportNav')[0];
					if($sidebarSportNav) {
						var sportId = this.model.view.filters.sport_id;
						var sportKey = this.model.view.filters.sport_key;
						$sidebarSportNav.__vueParentComponent.appContext.config.globalProperties.$store.commit('sports/SET_ACTIVE_SPORT_ID', sportId);
						$sidebarSportNav.__vueParentComponent.appContext.config.globalProperties.$store.commit('sports/SET_ACTIVE_SPORT_KEY', sportKey);
						$sidebarSportNav.__vueParentComponent.appContext.config.globalProperties.$store.commit('sports/SET_ACTIVE_DAY_KEY', 'today');
						$sidebarSportNav.__vueParentComponent.appContext.config.globalProperties.$store.commit('sports/RESET_ACTIVE_LEAGUE_IDS_PER_SPORT');
						$sidebarSportNav.__vueParentComponent.appContext.config.globalProperties.$router.push($sidebarSportNav.__vueParentComponent.appContext.config.globalProperties.$store.getters['sports/getEarlySportRoute']);
						if(GETCURRENTLAYOUT() === 'euro/eventRacing'){
							var sportUrl = Config.LOCALE_URL + '/sports/' + this.model.view.filters.sport_key;
							window.location.href = sportUrl;
						}
					}
				}
		 	}
		]
	}
}; /** ----------------- **/ 
 function euroSportDayFilter(){
	return {
		models:
		[
		 	{
		 		modelName: "CCU",
		 		childModel: "Day"
		 	},
			{
				modelName: "Day"
			}
		],
		views:
		[
		 	{
		 		viewName: "CCU",
		 		partial: "common/euro_sport_day_filter/euro_sport_day_filter_container",
                innerTarget: ".day-selection-nav",
		 		behaviours: ["pageUpdateHelper", "childReorder"],
				beforeInitialize: function(){
					this.targetEl = this.model.get("targetEl");
                    this.filters = getEuroSportFilters();
                    this.checkFilterVisibility(null, this.filters);
		 		},
                afterInitialize: function(){
                    this.on('EuroSportDayFilter_updateDaySelection', this.updateDaySelection);
                    this.on('SidebarNavigation_updateSelection', this.checkFilterVisibility);
                    this.on('EuroSportDayFilter_clearDaySelection', this.clearDaySelection);
                    this.on('EuroSportDayFilter_triggerSelectionUpdate', this.triggerSelectionUpdate);
                    this.on('EuroSportDayFilter_setFilterVisibility', this.setFilterVisibility);
                    this.pushComponents({
                        is_visible: {
                            callback: this.changeVisibility
                        }
                    })
                },
                clearDaySelection: function() {
                    var childList = this.model.childList.models;
                    _.each(childList, function (child) {
                        child.set('is_active', 0);
                    });
                },
                updateDaySelection: function(caller, data) {
                    if(data.value === 0) {
                        this.filters.time_range = "";
                    } else {
                        this.filters.time_range = data.selection;
                        this.trigger('EuroSportDayFilter_clearDaySelection');
                        this.trigger('EuroSportDayFilter_updateDayActiveStatus' + this.filters.time_range, 1);

                    }
                },
                triggerSelectionUpdate: function() {
                    var updateSelectionData = {
                        time_range: this.filters.time_range
                    };

                    this.trigger('EuroSportDayFilter_updateSelection', updateSelectionData);
                    var $sidebarSportNav = $('#sidebarSportNav')[0];
                    if($sidebarSportNav) {
                        $sidebarSportNav.__vueParentComponent.appContext.config.globalProperties.$store.commit('sports/SET_ACTIVE_DAY_KEY', this.filters.time_range);
                    }
                },

                setFilterVisibility: function(caller, value){
                    this.model.set('is_visible', value);
                },
                checkFilterVisibility: function(caller, data){
                    var view = this;
                    setTimeout(function(){
                        var outrightSport = _.findKey(SharedMarketsMap.outrightSports, function(value, key) {
                            return value == data.sport_id
                        });
                        if(data.league_id.length || outrightSport || getParameterByName('outrights') || data.real_events == 0){
                            view.model.set('is_visible', false);
                        }else{
                            view.model.set('is_visible', true);
                        }
                    })
                },
                changeVisibility: function(value, prev_value, element, key, $this){
                    if(value){
                        $this.$el.removeClass('d-none');
                    }else{
                        $this.$el.addClass('d-none');
                    }
                }

		 	},
            {
                viewName: "Day",
                partial: "common/euro_sport_day_filter/euro_sport_day_filter_day_item",
                events: {
                    "click .filter-day-item": "handleDayItemClick"
                },
                beforeInitialize: function(){
                    if((this.model.ccu.view.filters.sport_id == 1 ||this.model.ccu.view.filters.sport_id == 22) && this.model.get('key') == 'all'){
                        this.model.set('is_visible', false);
                    }else{
                        this.model.set('is_visible', true);
                    }
                    if(this.model.get('key') == 'all'){
                        this.on('EuroSportDayFilter_setAllVisible', this.setAllVisible);
                    }
                },
                afterInitialize: function() {
                    this.pushComponents({
                        is_active: {
                            callback: this.changeActiveStatus
                        },
                        is_visible: {
                            callback: this.changeVisibility
                        }
                    });
                    this.on('EuroSportDayFilter_updateDayActiveStatus' + this.model.get('key'), this.setActiveStatus);
                },
                setAllVisible: function(caller, value){
                    this.model.set('is_visible', value);
                },
                changeVisibility: function(value, prev_value, element, key, $this){
                    if(value){
                        $this.$el.removeClass('d-none');
                    }else{
                        $this.$el.addClass('d-none');
                    }
                },
                setActiveStatus: function(caller, isActive){
                    this.model.set('is_active', isActive);
                },
                changeActiveStatus: function (value, prev_value, element, key, $this) {
                    if(value === 1) {
                        $this.$el.find('.filter-day-item').addClass('active');
                    } else {
                        $this.$el.find('.filter-day-item').removeClass('active');
                    }
                },
                handleDayItemClick: function() {
                    if(this.model.get("is_active")) {
                        return;
                    }
                    this.model.ccu.view.filters.time_range = this.model.get("key");

                    this.trigger('EuroSportDayFilter_clearDaySelection');
                    this.model.set("is_active", 1);
                    this.trigger('EuroSportDayFilter_triggerSelectionUpdate');
                }
            }
		]
	}
}
